"use strict";

exports.__esModule = true;
var _exportNames = {
  makeConfig: true,
  t: true
};
exports.makeConfig = makeConfig;
exports.t = void 0;

var _utils = require("@chakra-ui/utils");

var _logicalProp = require("./logical-prop");

Object.keys(_logicalProp).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _logicalProp[key]) return;
  exports[key] = _logicalProp[key];
});

var _positiveOrNegative = require("./positive-or-negative");

Object.keys(_positiveOrNegative).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _positiveOrNegative[key]) return;
  exports[key] = _positiveOrNegative[key];
});

var _sort = require("./sort");

Object.keys(_sort).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _sort[key]) return;
  exports[key] = _sort[key];
});

var _types = require("./types");

Object.keys(_types).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _types[key]) return;
  exports[key] = _types[key];
});

function makeConfig(scale, transform) {
  return function (prop) {
    var result = {
      scale: scale
    };
    if (transform) result.transform = transform;
    if (Array.isArray(prop)) result.properties = prop;else result.property = prop;
    return result;
  };
}

function fractionalValue(value, scale) {
  var defaultValue = !(0, _utils.isNumber)(value) || value > 1 ? value : value * 100 + "%";
  return (0, _utils.get)(scale, value, defaultValue);
}

var t = {
  borderWidths: makeConfig("borderWidths"),
  borderStyles: makeConfig("borderStyles"),
  colors: makeConfig("colors", function (value, scale) {
    var resolvedValue = (0, _utils.get)(scale, value, value);
    return (0, _utils.isObject)(resolvedValue) ? value : resolvedValue;
  }),
  borders: makeConfig("borders"),
  radii: makeConfig("radii"),
  space: makeConfig("space"),
  spaceT: makeConfig("space", _positiveOrNegative.positiveOrNegative),
  prop: function prop(property, transform) {
    return {
      property: property,
      transform: transform
    };
  },
  sizes: makeConfig("sizes"),
  sizesT: makeConfig("sizes", fractionalValue),
  shadows: makeConfig("shadows"),
  logical: _logicalProp.logical
};
exports.t = t;
//# sourceMappingURL=index.js.map